import { render } from "./RequestsItem.vue?vue&type=template&id=6bfd586b&scoped=true"
import script from "./RequestsItem.vue?vue&type=script&lang=js"
export * from "./RequestsItem.vue?vue&type=script&lang=js"

import "./RequestsItem.vue?vue&type=style&index=0&id=6bfd586b&scoped=true&lang=css"

import exportComponent from "D:\\vue-js\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfd586b"]])

export default __exports__